import { CommonApis } from './modules/common-apis'
import { wxDownloadApis } from './modules/wx-download-apis'

/** 接口集合 */
export default class Apis {
    /** 公共接口 */
    common: CommonApis = new CommonApis()
    wxDownload: wxDownloadApis = new wxDownloadApis()
}
